import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';
import WeatherIcons from 'react-weathericons';

import {
		CLOUDY,
		SUN,
		CLOUD,
		RAIN, 
		SNOW,
		WINDY,
		THUNDER,
		DRIZZLE
} from './../../../constant/weathers';
import  './style.css';

const stateToIconName = (weatherState) =>{

	switch (weatherState) {
		case CLOUD:
			return 'cloud';
		case CLOUDY:
			return 'cloudy';
		case SUN:
			return 'day-sunny';
		case RAIN:
			return 'rain';
		case SNOW:
			return 'snow';
		case WINDY:
			return 'windy';
		case THUNDER:
			return 'day-thunderstorm';
		case DRIZZLE:
			return 'day-showers';
		default:
			return 'day-sunny';
	}

}
const getWeatherIcon = (weatherState) => {
	return	(
		 
		 <WeatherIcons name={stateToIconName(weatherState)}  size="3x" />

		)
}


const WeatherTemperature = ({temperature, weatherState}) => (

	<div className="iconss">
	<Col xs={6}>
	{getWeatherIcon(weatherState)}		
	  <span>{`${temperature} °C`}</span>

	</Col>
	</div> 
	)

WeatherTemperature.propTypes ={
	temperature:PropTypes.number.isRequired,
	weatherState:PropTypes.string.isRequired,
}

export default  WeatherTemperature ;


// WEBPACK FOOTER //
// ./src/components/WeatherLocation/WeatherData/WeatherTemperature.js